import { backendApi } from "./APIs";
import { getUser } from "./Common";

export const Post = async (url, args, loader = null) => {
   var user = getUser();
   if (user) args.token = user.token;

   if (loader) loader(true);

   try {
      let resp = await backendApi.post(url, args);
      if (loader) loader(false);
      if (!resp.data) return { 'estatus': false, msj: 'Error de conexión, por favor intentelo más tarde' };
      return resp.data;
   } catch (error) {
      if (loader) loader(false);
      return { 'estatus': false, msj: 'Ocurrió un error: ' + error };
   }
}

export default Post;